import * as PID from '~/modules/retailMedia/components/CampaignForm/hooks/constants/publisherIds'

const allowerBypassLogoValidation = [PID.SEPHORA, PID.RM_TESTES_PUBLISHER]

export const bypassLogoValidation = (publisherId: PublisherId) => {
  return allowerBypassLogoValidation.includes(publisherId)
}
